import { RadioGroup, StackProps, VStack } from '@chakra-ui/react';
import { ReactElement, ReactNode } from 'react';

type TVRadioGroupVerticalOption = {
  label: ReactNode;
  value: string;
};

type VRadioGroupVerticalProps = Omit<RadioGroup.RootProps, 'orientation'> & {
  options?: TVRadioGroupVerticalOption[];
  gap?: StackProps['gap'];
};

const VRadioGroupVertical = ({
  options = [],
  gap = '6',
  ...props
}: VRadioGroupVerticalProps): ReactElement => (
  <RadioGroup.Root orientation="vertical" {...props}>
    <VStack gap={gap} alignItems="flex-start">
      {options.map((option) => (
        <RadioGroup.Item key={option.value} value={option.value}>
          <RadioGroup.ItemHiddenInput />
          <RadioGroup.ItemIndicator />
          <RadioGroup.ItemText>{option.label}</RadioGroup.ItemText>
        </RadioGroup.Item>
      ))}
    </VStack>
  </RadioGroup.Root>
);

export default VRadioGroupVertical;
export type { VRadioGroupVerticalProps };
